// extracted by mini-css-extract-plugin
module.exports = {"divider":"PlayerMenuComponent_divider__2UjsK"};